import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import AddRoleAccessteps from "@/Components/common/client/useraccess/roleaccess/RoleAccessSteps/AddRoleAccessteps";
import FeatureAccess from "@/Components/common/client/useraccess/roleaccess/RoleAccessSteps/FeatureAccess";
import ModuleAccess from "@/Components/common/client/useraccess/roleaccess/RoleAccessSteps/ModuleAccess";
import RoleBasicInfo from "@/Components/common/client/useraccess/roleaccess/RoleAccessSteps/RoleBasicInfo";
import { resetForm } from "@/reducers/client_user/roleAccess";

import { fetchClientBranches } from "../../../../reducers/clientcommon";
import useTitle from "../../../../utilities/hooks/useTitle";

const AddRoleAccess = () => {
  useTitle("Add New Role");
  const { activeStep } = useSelector((state) => state.clientRoles);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchClientBranches({}));
    dispatch(resetForm());
  }, []);
  return (
    <>
      <AddRoleAccessteps />
      {activeStep === 1 ? <RoleBasicInfo /> : null}
      {activeStep === 2 ? <ModuleAccess /> : null}
      {activeStep === 3 ? <FeatureAccess /> : null}
    </>
  );
};

export default AddRoleAccess;
